import type { FormResponseStatus } from '@/views/Project/Form/types/form'

export default {
    name: 'FormResponseMixin',
    computed: {
        statusColor(): Record<FormResponseStatus, string> {
            return {
                open: 'grey',
                done: 'green',
                pendingApproval: 'orange',
                rejected: 'red',
            }
        },
    },
}
